import { render, staticRenderFns } from "./IndividualResult.vue?vue&type=template&id=734f4b86&scoped=true&"
import script from "./IndividualResult.vue?vue&type=script&lang=js&"
export * from "./IndividualResult.vue?vue&type=script&lang=js&"
import style0 from "./IndividualResult.vue?vue&type=style&index=0&id=734f4b86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734f4b86",
  null
  
)

export default component.exports